var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-login" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("section", { staticClass: "login" }, [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "login-form" }, [
          _c("h1", [_vm._v(_vm._s(_vm.trans("passwords.reset_password")))]),
          _vm._v(" "),
          !_vm.showMessage
            ? _c("div", [
                _c(
                  "form",
                  {
                    staticClass: "form-horizontal form-material",
                    attrs: { id: "resetForm" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.submit.apply(null, arguments)
                      },
                      keydown: function ($event) {
                        return _vm.resetForm.errors.clear($event.target.name)
                      },
                    },
                  },
                  [
                    _c("label", { attrs: { for: "email" } }, [_vm._v("Email")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.resetForm.email,
                          expression: "resetForm.email",
                        },
                      ],
                      attrs: { type: "text", name: "email" },
                      domProps: { value: _vm.resetForm.email },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.resetForm, "email", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.resetForm,
                        "prop-name": "email",
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "password" } }, [
                      _vm._v("Password"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.resetForm.password,
                          expression: "resetForm.password",
                        },
                      ],
                      attrs: { type: "password", name: "password" },
                      domProps: { value: _vm.resetForm.password },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.resetForm,
                            "password",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.resetForm,
                        "prop-name": "password",
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "password" } }, [
                      _vm._v(_vm._s(_vm.trans("auth.confirm_password"))),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.resetForm.password_confirmation,
                          expression: "resetForm.password_confirmation",
                        },
                      ],
                      attrs: { type: "password", name: "password" },
                      domProps: { value: _vm.resetForm.password_confirmation },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.resetForm,
                            "password_confirmation",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("show-error", {
                      attrs: {
                        "form-name": _vm.resetForm,
                        "prop-name": "password_confirmation",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        staticStyle: { "margin-top": "30px" },
                      },
                      [_vm._v(_vm._s(_vm.trans("passwords.reset_password")))]
                    ),
                  ],
                  1
                ),
              ])
            : _c("div", { staticClass: "text-center" }, [
                _vm.status
                  ? _c("h4", {
                      staticClass: "alert alert-success",
                      domProps: { textContent: _vm._s(_vm.message) },
                    })
                  : _c("h4", {
                      staticClass: "alert alert-danger",
                      domProps: { textContent: _vm._s(_vm.message) },
                    }),
              ]),
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "clear" }),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", [
      _c("div", { staticClass: "content" }, [
        _c("a", { attrs: { href: "/" } }, [
          _c("img", {
            staticClass: "header-logo",
            attrs: { src: "/images/logo.svg" },
          }),
        ]),
        _vm._v(" "),
        _c(
          "a",
          { staticClass: "header-button-si", attrs: { href: "/login" } },
          [_vm._v("Sign In")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "login-hiw" }, [
      _c("h2", [_vm._v("Here’s how it works")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("i", [_vm._v("1")]),
          _c("h3", [_vm._v("Complete our first questionnaire")]),
          _c("p", [
            _vm._v(
              "Tell us more about your investor preferences and your investment offering"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("i", [_vm._v("2")]),
          _c("h3", [_vm._v("Get some free, suitable investor insights")]),
          _c("p", [_vm._v("based on the information submitted")]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("i", [_vm._v("3")]),
          _c("h3", [_vm._v("Book a video call with one of our experts")]),
          _c("p", [
            _vm._v("Our team will review your offering and give you a quote"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clear" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }